<template>
  <div @click="navTo" class="lecture-item">
    <div
      target="_blank"
      :to="{ path: '/notedetail', query: { id: obj.id } }"
      class="lecture-item-cover"
    >
      <img :src="obj.image" class="img" alt="" />
      <div class="tag">{{ obj.cate_id }}</div>
      <div class="time">{{ obj.duration }}</div>
    </div>
    <div
      target="_blank"
      :to="{ path: '/notedetail', query: { id: obj.id } }"
      class="lecture-item-title"
    >
      {{ obj.title }}
    </div>
    <div class="lecture-item-intro">
      {{ obj.intro }}
    </div>
    <div class="lecture-item-bottom">
      <div class="icon-item">
        <i class="iconfont icon-good"></i>
        <span class="nub">{{ obj.mark | formatUnit }}</span>
      </div>
      <div class="icon-item">
        <i class="iconfont icon-pinglun1"></i>
        <span class="nub">{{ obj.comment | formatUnit }}</span>
      </div>
      <div class="icon-item">
        <i class="iconfont icon-browse"></i>
        <span class="nub">{{ obj.views | formatUnit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    obj: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    navTo(){
      this.$emit('tab',{})
    }
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.lecture-item {
  width: 378px;
  display: flex;
  flex-direction: column;
  &-cover {
    cursor: pointer;
    display: flex;
    background-color: #58b75b;
    height: 216px;
    border-radius: 10px;
    position: relative;
    .img {
      object-fit: cover;
      width: 100%;
      border-radius: 10px;
      box-shadow: 0 0 2px #eee;
    }
    .tag {
      font-size: 12px;
      position: absolute;
      left: 0;
      top: 10px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      line-height: 20px;
      height: 20px;
      padding: 0 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .time {
      font-size: 12px;
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #fff;
      padding: 0px 10px;
      line-height: 20px;
      height: 20px;
      border-radius: 20px;
      background-color: rgba(0, 0, 0, 0.4);
    }
  }
  &-title {
    cursor: pointer;
    color: #333;
    margin-top: 30px;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  &-intro {
    margin-top: 20px;
    font-size: 12px;
    // line-height: 1.5;
    height: 40px;
    line-height: 20px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  &-bottom {
    margin-top: 25px;
    display: flex;
    align-items: center;
    .icon-item {
      color: #999;
      font-size: 13px;
      margin-right: 15px;
      vertical-align: middle;
      .iconfont {
        margin-right: 3px;
        font-size: 15px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/lectureItem.vue